// FS-2026-064: render the platform's bilingual legal text without raw HTML.
import Box from "@mui/material/Box";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";

export default function LegalDocumentText({ children }: { children: string }) {
  return (
    <Box
      sx={{
        overflowWrap: "anywhere",
        "& h1": { typography: "h4", mt: 3, mb: 2 },
        "& h2": { typography: "h5", mt: 3, mb: 2 },
        "& h3": { typography: "h6", mt: 2, mb: 1 },
        "& p, & li": { typography: "body1", lineHeight: 1.7 },
        "& a": { color: "primary.main" },
        "& table": {
          display: "block",
          overflowX: "auto",
          borderCollapse: "collapse",
        },
        "& th, & td": {
          p: 1.5,
          border: 1,
          borderColor: "divider",
          textAlign: "left",
        },
      }}
    >
      <ReactMarkdown remarkPlugins={[remarkGfm]}>{children}</ReactMarkdown>
    </Box>
  );
}
